var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LightboxContentLayout',{attrs:{"accessibilityText":_vm.data.accessibility_text,"ariaDescription":undefined,"captionText":_vm.data.caption,"accessibilityTextFlag":false}},[_c('iframe',{staticClass:"full-screen",attrs:{"src":_vm.pdf,"seamless":"true","frameBorder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }